import { createFileRoute } from '@tanstack/react-router'
import { PaymentsLogPage } from '@/features/finance/payments-log/pages/payments-log-page'
import type { PaymentLogTypeFilter } from '@/features/finance/payments-log/types/payments-log.types'
import { requireRole } from '@/lib/auth-guards'

const adminPaymentTypes = new Set<PaymentLogTypeFilter>(['all', 'gateway', 'allocation'])

export const Route = createFileRoute('/_authenticated/finance/payments')({
  validateSearch: (search: Record<string, unknown>) => {
    const raw = typeof search.type === 'string' ? search.type : ''
    const type: PaymentLogTypeFilter = adminPaymentTypes.has(raw as PaymentLogTypeFilter)
      ? (raw as PaymentLogTypeFilter)
      : 'all'
    return { type }
  },
  component: AdminPaymentsPage,
  beforeLoad: requireRole(['admin']),
})

function AdminPaymentsPage() {
  const { type } = Route.useSearch()
  return <PaymentsLogPage role='admin' initialType={type} />
}
